<div class="bg-white border m-2 py-3 px-3 shadow-sm">
  <h5>Staff</h5>
  <era-device-link-selector [selection]="selection$ | async"
                            [isSpare]="false"
                            [isStaff]="true"
                            (selectionChange)="updateSelection($event)">
  </era-device-link-selector>
  <button type="submit"
          class="btn btn-success me-2"
          (click)="staff()">Staff</button>
  <a type="cancel"
     class="btn btn-outline-primary"
     [routerLink]="['../']">Cancel</a>
</div>